import classNames from 'classnames';
import React from 'react';
import { useIntl } from 'react-intl';
import styles from './dark-mode-toggle.module.scss';
import { SVGS } from '../../assets/images';
import { Lx } from '../../i18n/consts';

interface DarkModeToggleProps {
    checked: boolean;
    onChange?: (checked: boolean) => void;
    label?: string;
    className?: string;
    showLabel?: boolean;
}

export const DarkModeToggle: React.FC<DarkModeToggleProps> = ({ checked, onChange, label, className, showLabel = true }) => {
    const intl = useIntl();
    const handleClick = () => {
        onChange?.(!checked);
    };
    const defaultLabel = checked
        ? intl.formatMessage({ id: Lx.Theme.DARK_MODE })
        : intl.formatMessage({ id: Lx.Theme.LIGHT_MODE });
    const resolvedLabel = label ?? defaultLabel;

    const thumbIconClassName = classNames(styles.icon, checked ? styles.moonIcon : styles.sunIcon);

    return (
        <div className={classNames(styles.container, className)}>
            <button
                type='button'
                className={classNames(styles.toggleButton, { [styles.checked]: checked })}
                onClick={handleClick}
                aria-pressed={checked}
                aria-label={resolvedLabel}>
                <span className={styles.track}>
                    <span className={classNames(styles.iconWrapper, styles.sunGhost)}>
                        {checked ? (
                            <SVGS.SunIconDark width={12} height={12} className={classNames(styles.icon, styles.sunIcon)} />
                        ) : (
                            <SVGS.SunIconLight width={12} height={12} className={classNames(styles.icon, styles.sunIcon)} />
                        )}
                    </span>
                    <span className={classNames(styles.iconWrapper, styles.moonGhost)}>
                        {checked ? (
                            <SVGS.MoonIconDark width={12} height={12} className={classNames(styles.icon, styles.moonIcon)} />
                        ) : (
                            <SVGS.MoonIconLight width={12} height={12} className={classNames(styles.icon, styles.moonIcon)} />
                        )}
                    </span>
                    <span className={classNames(styles.thumb, { [styles.thumbChecked]: checked })}>
                        {checked ? (
                            <SVGS.MoonIconDark width={12} height={12} className={thumbIconClassName} />
                        ) : (
                            <SVGS.SunIconLight width={12} height={12} className={thumbIconClassName} />
                        )}
                    </span>
                </span>
            </button>
            {showLabel && (
                <span
                    className={styles.label}>
                    {resolvedLabel}
                </span>
            )}
        </div>
    );
};

export default DarkModeToggle;
